





































































import { Component, Vue } from 'vue-property-decorator'
import logo from '@/assets/logo.png'
import { BASE_URL } from '../config'

@Component({})
export default class Home extends Vue {
  public logo = logo
  public radius = this.$store.getters.radius
  get sideMenuOpen() {
    return this.$store.getters.sideMenuOpen
  }
  set sideMenuOpen(value) {
    this.$store.dispatch('setSideMenu', value)
  }
  public setRadius(value: number) {
    this.$store.dispatch('setRadius', value)
  }
  public openExternalLink(href: string, inTab: boolean) {
    ;(this as any).$ga.event('menu', 'openLink', href)
    window.open(href, inTab ? '_blank' : '_self')
  }
  get ciudad() {
    return this.$store.getters.getCiudad
  }
  set ciudad(ciudadSlug) {
    ;(this as any).$ga.event('menu', 'setCiudad', ciudadSlug)
    this.$store.dispatch('setCiudad', ciudadSlug)
    window.open(`${BASE_URL}${ciudadSlug}/`, '_self')
  }
  get ciudades() {
    return this.$store.getters.getCiudades
  }
}
